"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartProvider = exports.useCart = exports.CartConsumer = void 0;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const react_1 = __importStar(require("react"));
const index_1 = require("./index");
const CartContext = react_1.createContext({
    cart: undefined,
    error: 'Provider not used'
});
exports.CartConsumer = CartContext.Consumer;
exports.useCart = () => react_1.useContext(CartContext);
exports.CartProvider = ({ options, children }) => {
    let [cart, setCart] = react_1.useState();
    let [error, setError] = react_1.useState();
    const value = react_1.useMemo(() => ({
        cart,
        error
    }), [cart, error]);
    react_1.useEffect(() => {
        const setup = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const cartLib = yield index_1.cartSetup(options);
                setCart(cartLib);
            }
            catch (err) {
                setError(err);
            }
        });
        if (options.websiteId && !cart) {
            setup();
        }
    }, [options]);
    return (react_1.default.createElement(CartContext.Provider, { value: value }, children));
};
//# sourceMappingURL=react.js.map